module.exports = __webpack_public_path__ + "static/img/3.ecdaf3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/help/3.png
// module id = 55+g
// module chunks = 0